<template>
  <IconicButton
    :text="fullScreenProps.text"
    :icon="fullScreenProps.icon"
    @click="$emit('input', !isExpanded)"
  />
</template>

<script>
import IconicButton from '@@/advertisement/common/IconicButton';

export default {
  name: 'FullScreenButton',
  components: {
    IconicButton,
  },
  model: {
    prop: 'isExpanded',
    event: 'input',
  },
  props: {
    isExpanded: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    fullScreenProps() {
      return {
        text: this.isExpanded
          ? this.$t('ADVERTISEMENT.EXIT_FULL_SCREEN')
          : this.$t('ADVERTISEMENT.ENTER_FULL_SCREEN'),
        icon: this.isExpanded ? 'fullscreen_exit' : 'fullscreen',
      };
    },
  },
};
</script>
